@switch (specificTemplateName) {
  @case (documentTableNames.DocumentOverview) {
    <app-document-overview-template
      [columnName]="columnName"
      [element]="element"
    ></app-document-overview-template>
  }
  @case (documentTableNames.DocumentRevisions) {
    <app-document-revisions-template
      [columnName]="columnName"
      [element]="element"
    ></app-document-revisions-template>
  }
  @case (documentTableNames.DocumentReadReceiptRequests) {
    <app-document-read-receipt-requests-template
      [columnName]="columnName"
      [element]="element"
    ></app-document-read-receipt-requests-template>
  }
  @default {
    <app-default-cell [columnName]="columnName" [element]="element"></app-default-cell>
  }
}
